import { Target } from "lucide-react";
import { Section, LockableCard } from "@/components/plan/common";

function PersonaCard({ label, persona }) {
  if (!persona) return null;
  return (
    <div className="bg-white border border-zinc-200 rounded-2xl p-6 h-full">
      <div className="text-xs uppercase tracking-widest text-zinc-500">{label}</div>
      <div className="font-display font-black text-2xl mt-1">{persona.name}</div>
      <p className="text-sm text-zinc-600 mt-2">{persona.demographics}</p>
      <p className="text-sm text-zinc-500 mt-2">{persona.psychographics}</p>
      <div className="mt-4 text-xs uppercase tracking-widest text-zinc-500">Pain points</div>
      <ul className="mt-1 text-sm space-y-1">
        {persona.pain_points?.map((p, i) => <li key={`pp-${i}-${p.slice(0, 20)}`}>• {p}</li>)}
      </ul>
      <div className="mt-3 text-xs uppercase tracking-widest text-zinc-500">Buying triggers</div>
      <ul className="mt-1 text-sm space-y-1">
        {persona.buying_triggers?.map((p, i) => <li key={`bt-${i}-${p.slice(0, 20)}`}>• {p}</li>)}
      </ul>
    </div>
  );
}

export default function TargetAudienceSection({ audience, isFree }) {
  if (!audience) return null;
  return (
    <Section icon={Target} title="Target audience">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <PersonaCard label="Primary persona" persona={audience.primary_persona} />
        <LockableCard locked={isFree}>
          <PersonaCard label="Secondary persona" persona={audience.secondary_persona} />
        </LockableCard>
      </div>
    </Section>
  );
}
